import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import APH120 from 'dc/APH120';
import { Typ20, Typ42 } from 'dc/Typ';
import { ShortWrapper } from '../elements';

export const Wrapper = styled(ShortWrapper)`
  background: #ffffff;
`;

export const ProfileWrapper = styled(Wra16A)`
  width: 100%;
`;

export const Header = styled(APH120)`
  max-width: 100%;

  > div > i {
    color: #90a4ae;
  }
`;

export const TextWrapper = styled(Wra16A)`
  background: #007565;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled(Typ42)`
  text-align: center;
  color: #fff;
  max-width: 100%;
`;

export const Subtitle = styled(Typ20)`
  text-align: center;
  color: #fff;
  max-width: 100%;
`;

export const TeamWrapper = styled(Wra16A)`
  width: 100%;
  display: flex;
  justify-content: center;
`;
